import { AxiosResponse } from 'axios';
import { useAxios } from '../../composables/axios';
import { Region } from '../region/region.model';

const axios = useAxios();

export interface FiscalYearRegionService {
  Fetch: (fiscalYearId: number) => Promise<AxiosResponse<Region[]>>;
}

const Fetch = (fiscalYearId: number): Promise<AxiosResponse<Region[]>> =>
  axios.Get<Region[]>(`/api/fiscalyears/${fiscalYearId}/regions`);

export default { Fetch } as FiscalYearRegionService;
